import { useCallback, useMemo } from "react";
import {
  useAddFieldValidation,
  useFormField
} from "@workwave-tidal/form-fairy";
import { validateTidalLicense } from "@workwave-tidal/core/base";
import { useDebounceValue } from "./useDebounceValue.js";
import { useErrorHelper } from "./useErrorHelper.js";
import { useIsFieldRequired } from "./useIsRequired.js";
import { useValidateOn } from "./useValidateOn.js";
const noopOnValidate = () => {
};
function useFormFairyBridge(props) {
  const {
    debounce,
    errorVisibility = "all",
    fullWidth,
    helperText,
    label,
    name,
    testId,
    validateOn,
    validateWhenRequired,
    onValidate = noopOnValidate,
    onValidateOptions,
    ...userFieldOptions
  } = props;
  const {
    errors: fieldErrors,
    field,
    fieldApi: { change: apiChange, validate },
    formApi
  } = useFormField(
    name,
    userFieldOptions
  );
  const { required, status, disabled } = field;
  const disableRequiredValidation = !(validateWhenRequired && required);
  useIsFieldRequired(name, {
    disabled: disableRequiredValidation,
    priority: 100
  });
  const { validateOnBlur, validateOnChange, validateOnFocus } = useValidateOn(validate, validateOn);
  const changeAndValidate = useCallback(
    (value2) => {
      apiChange(value2);
      validateOnChange();
    },
    [validateOnChange, apiChange]
  );
  const options = useMemo(
    () => Object.assign({}, onValidateOptions, { disabled: onValidate === noopOnValidate }),
    [onValidate, onValidateOptions]
  );
  useAddFieldValidation(
    name,
    //@ts-expect-error FIXME
    onValidate,
    options
  );
  const [value, onChange] = useDebounceValue(field.value, changeAndValidate, debounce);
  const onBlur = useCallback(() => {
    validateOnBlur();
  }, [validateOnBlur]);
  const onFocus = useCallback(() => {
    validateOnFocus();
  }, [validateOnFocus]);
  const { errorOrHelperText, errorText, fieldHasError, showErrorAccent, showErrorText, showHelperText } = useErrorHelper(fieldErrors, errorVisibility, helperText, status);
  const fieldDisabled = disabled || formApi.getMeta().submitting || formApi.getMeta().disabled;
  return {
    // user config
    config: {
      name,
      label,
      testId,
      fullWidth,
      helperText
    },
    // form status and data
    fieldInfo: {
      field,
      value,
      onChange,
      onBlur,
      onFocus,
      showErrorText,
      showErrorAccent,
      showHelperText,
      errorText,
      fieldHasError,
      errorOrHelperText,
      fieldDisabled
    }
  };
}
validateTidalLicense();
export {
  useFormFairyBridge
};
//# sourceMappingURL=useFormFairyBridge.js.map
